import { isIos } from '@measures/responsive'

let scrollPosition = 0

const lockBodyScroll = () => {
  const scrollBarWidth = window.innerWidth - document.body.clientWidth
  document.body.style.overflow = 'hidden'
  // We need this to avoid content is shifted to the right when the burger menu is opened and the scrollbar disappears
  if (scrollBarWidth > 0) {
    document.body.style.paddingRight = `${scrollBarWidth}px`
  }
  if (isIos()) {
    scrollPosition = window.pageYOffset
    document.body.style.position = 'fixed'
    document.body.style.top = `-${scrollPosition}px`
    document.body.style.width = '100%'
  }
}

const unlockBodyScroll = (resetScrollPosition?: boolean) => {
  document.body.style.removeProperty('overflow')
  document.body.style.paddingRight = ''
  if (isIos()) {
    document.body.style.removeProperty('position')
    document.body.style.removeProperty('top')
    document.body.style.removeProperty('width')
    if (resetScrollPosition) {
      scrollPosition = 0
    }
    window.scrollTo(0, scrollPosition)
  }
}

export { lockBodyScroll, unlockBodyScroll }
